import LuxuryCollectionPage from "../../components/pages/luxuryseriespage";

export default LuxuryCollectionPage;
